<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs">
     CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_da" title="Sikkerhedsoplysninger">
     Sikkerhedsoplysninger
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konventioner">
      Konventioner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="Produkterkl&aelig;ringer">
      Produkterkl&aelig;ringer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_da" title="F&aring; oplysninger om printeren">
     F&aring; oplysninger om printeren
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_da" title="S&aring;dan finder du oplysninger om printeren">
      S&aring;dan finder du oplysninger om printeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_da" title="S&aring;dan finder du printerens serienummer">
      S&aring;dan finder du printerens serienummer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_da" title="Printerkonfigurationer">
      Printerkonfigurationer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_da" title="Brug af kontrolpanelet">
      Brug af kontrolpanelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_da" title="Ikoner p&aring; startsk&aelig;rm">
      Ikoner p&aring; startsk&aelig;rm
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_da" title="Indikatorlampeens farver">
      Indikatorlampeens farver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_da" title="Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade">
      Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_da" title="Lokalisering af sikkerheds&aring;bningen">
      Lokalisering af sikkerheds&aring;bningen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="Valg af papir">
      Valg af papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10681" title="Yderligere printerfunktioner og support">
      Yderligere printerfunktioner og support
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_da" title="Ops&aelig;tning, installation og konfiguration">
     Ops&aelig;tning, installation og konfiguration
    </a>
   </p>
   <div id="divd0e10808">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_da" title="Valg af en placering til printeren">
      Valg af en placering til printeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_da" title="Printerporte">
      Printerporte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e11007" title="Konfiguration af apps og l&oslash;sninger">
      Konfiguration af apps og l&oslash;sninger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11184" title="Konfiguration og brug af tilg&aelig;ngelighedsfunktioner">
      Konfiguration og brug af tilg&aelig;ngelighedsfunktioner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11489" title="Ops&aelig;tning af printeren til faxning">
      Ops&aelig;tning af printeren til faxning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_da" title="Il&aelig;gning af papir og specialmedier">
      Il&aelig;gning af papir og specialmedier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12285" title="Installation og opdatering af software, drivere og firmware">
      Installation og opdatering af software, drivere og firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12611" title="Installere hardwareoptioner">
      Installere hardwareoptioner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14142" title="Netv&aelig;rk">
      Netv&aelig;rk
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_da" title="Sikring af printeren">
     Sikring af printeren
    </a>
   </p>
   <div id="divd0e14494">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_da" title="Sletning af printerhukommelse">
      Sletning af printerhukommelse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_da" title="Sletning af printerens lagerdrev">
      Sletning af printerens lagerdrev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_da" title="Gendannelse af fabriksindstillinger">
      Gendannelse af fabriksindstillinger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_da" title="Erkl&aelig;ring om flygtighed">
      Erkl&aelig;ring om flygtighed
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_da" title="Udskrivning">
     Udskrivning
    </a>
   </p>
   <div id="divd0e14686">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_da" title="Udskrivning fra en computer">
      Udskrivning fra en computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14737" title="Udskrive fra en mobil enhed">
      Udskrive fra en mobil enhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_da" title="Udskrivning fra et flashdrev">
      Udskrivning fra et flashdrev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_da" title="Konfiguration af fortrolige job">
      Konfiguration af fortrolige job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_da" title="Udskrive fortrolige og andre tilbageholdte job">
      Udskrive fortrolige og andre tilbageholdte job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_da" title="Udskrivning af skrifttypeeksempler">
      Udskrivning af skrifttypeeksempler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_da" title="Udskrive en mappeliste">
      Udskrive en mappeliste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_da" title="Placering af skillesider i udskriftsjob">
      Placering af skillesider i udskriftsjob
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_da" title="Annullering af et udskriftsjob">
      Annullering af et udskriftsjob
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_da" title="Justering af tonersv&aelig;rtningsgrad">
      Justering af tonersv&aelig;rtningsgrad
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_da" title="Kopiering">
     Kopiering
    </a>
   </p>
   <div id="divd0e15232">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_da" title="Oprettelse af kopier">
      Oprettelse af kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_da" title="Kopiering af fotos">
      Kopiering af fotos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_da" title="Kopiering p&aring; brevpapir">
      Kopiering p&aring; brevpapir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_da" title="Kopiering p&aring; begge sider af papiret">
      Kopiering p&aring; begge sider af papiret
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_da" title="Reducer eller forst&oslash;r st&oslash;rrelsen af kopier">
      Reducer eller forst&oslash;r st&oslash;rrelsen af kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_da" title="Sortering af kopier">
      Sortering af kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_da" title="Placering af skillesider mellem kopier">
      Placering af skillesider mellem kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_da" title="Kopiering af flere sider til et enkelt ark">
      Kopiering af flere sider til et enkelt ark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_da" title="Kopiere kort">
      Kopiere kort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_da" title="Oprettelse af en kopigenvej">
      Oprettelse af en kopigenvej
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_da" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e15505">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_da" title="Konfiguration af SMTP-indstillinger">
      Konfiguration af SMTP-indstillinger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_da" title="Sende en e-mail">
      Sende en e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_da" title="Oprettelse af en genvej til e-mail">
      Oprettelse af en genvej til e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_da" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e16954">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_da" title="Afsendelse af en fax">
      Afsendelse af en fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_da" title="Planl&aelig;gning af en fax">
      Planl&aelig;gning af en fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_da" title="Oprettelse af en faxdestinationsgenvej">
      Oprettelse af en faxdestinationsgenvej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_da" title="&AElig;ndring af faxopl&oslash;sning">
      &AElig;ndring af faxopl&oslash;sning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_da" title="Justering af faxens m&oslash;rkhed">
      Justering af faxens m&oslash;rkhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_da" title="Udskriv en faxlog">
      Udskriv en faxlog
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_da" title="Blokering af u&oslash;nskede faxmeddelelser">
      Blokering af u&oslash;nskede faxmeddelelser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_da" title="Tilbageholdelse af faxer">
      Tilbageholdelse af faxer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_da" title="Videresendelse af en fax">
      Videresendelse af en fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_da" title="Scanning">
     Scanning
    </a>
   </p>
   <div id="divd0e17250">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_da" title="Scanning til en computer">
      Scanning til en computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_da" title="Scanning til en FTP-server">
      Scanning til en FTP-server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_da" title="Oprettelse af en FTP-genvej">
      Oprettelse af en FTP-genvej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_da" title="Scanning til en netv&aelig;rksmappe">
      Scanning til en netv&aelig;rksmappe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_da" title="Konfigurering af en netv&aelig;rksfolderdestination">
      Konfigurering af en netv&aelig;rksfolderdestination
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_da" title="Opret genvej til en netv&aelig;rksmappe">
      Opret genvej til en netv&aelig;rksmappe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_da" title="Scanning til et flashdrev">
      Scanning til et flashdrev
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_da" title="Printermenuer">
     Printermenuer
    </a>
   </p>
   <div id="divd0e17539">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_da" title="Menuoversigt">
      Menuoversigt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17853" title="Enhed">
      Enhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20087" title="Udskrivning">
      Udskrivning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21369" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21701" title="Kopiering">
      Kopiering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22260" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24127" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25224" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25930" title="USB-drev">
      USB-drev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26776" title="Netv&aelig;rk/porte">
      Netv&aelig;rk/porte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28927" title="Sikkerhed">
      Sikkerhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e30024" title="Cloud-services">
      Cloud-services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30081" title="Rapporter">
      Rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_da" title="Fejlfinding">
      <strong>
       Fejlfinding
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_da" title="Formularfletning">
      <strong>
       Formularfletning
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_da" title="Udskrivning af siden med menuindstillinger">
      Udskrivning af
      <strong>
       siden med menuindstillinger
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_da" title="Printerindstillinger for efterbehandling">
     Printerindstillinger for efterbehandling
    </a>
   </p>
   <div id="divd0e30564">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_da" title="Brug af h&aelig;fteefterbehandleren">
      Brug af h&aelig;fteefterbehandleren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_da" title="Brug af efterbehandleren til h&aelig;ftning og hulning">
      Brug af efterbehandleren til h&aelig;ftning og hulning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_da" title="Brug af offset-stableren">
      Brug af offset-stableren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_da" title="S&aring;dan bruger efterbehandleren til brochurer">
      S&aring;dan bruger efterbehandleren til brochurer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_da" title="Anvendelse af papirtransport med foldeindstilling">
      Anvendelse af papirtransport med foldeindstilling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_da" title="Vedligeholdelse af printeren">
     Vedligeholdelse af printeren
    </a>
   </p>
   <div id="divd0e30974">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_da" title="Kontrol af status for dele og forbrugsstoffer">
      Kontrol af status for dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_da" title="Konfiguration af meddelelser om forbrugsstoffer">
      Konfiguration af meddelelser om forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_da" title="Ops&aelig;tning af e-mail-advarsler">
      Ops&aelig;tning af e-mail-advarsler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_da" title="Generering af rapporter og logs">
      Generering af rapporter og logs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_da" title="Bestilling af dele og forbrugsstoffer">
      Bestilling af dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31829" title="Udskiftning af dele og forbrugsstoffer">
      Udskiftning af dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32453" title="Reng&oslash;ring af printerens dele">
      Reng&oslash;ring af printerens dele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32617" title="Spare energi og papir">
      Spare energi og papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_da" title="Flytning af printeren til et andet sted">
      Flytning af printeren til et andet sted
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_da" title="Fejlfinding af et problem">
     Fejlfinding af et problem
    </a>
   </p>
   <div id="divd0e32755">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_da" title="Problemer med udskriftskvalitet">
      Problemer med udskriftskvalitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_da" title="Printerfejlkoder">
      Printerfejlkoder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_da" title="Udskrivningsproblemer">
      Udskrivningsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_da" title="Printeren reagerer ikke">
      Printeren reagerer ikke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_da" title="Det var ikke muligt at l&aelig;se flashdrevet">
      Det var ikke muligt at l&aelig;se flashdrevet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_da" title="Aktivering af USB-porten">
      Aktivering af USB-porten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_da" title="Rydning af papirstop">
      Rydning af papirstop
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36179" title="Problemer med netv&aelig;rksforbindelsen">
      Problemer med netv&aelig;rksforbindelsen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36272" title="Problemer med hardwareoptioner">
      Problemer med hardwareoptioner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36445" title="Problemer med forbrugsstoffer">
      Problemer med forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36593" title="Problemer med papirindf&oslash;ring">
      Problemer med papirindf&oslash;ring
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36787" title="Problemer med e-mail">
      Problemer med e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36842" title="Faxproblemer">
      Faxproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37164" title="Scanningsproblemer">
      Scanningsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37582" title="Problemer med farvekvaliteten">
      Problemer med farvekvaliteten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_da" title="Kontakt til kundesupport">
      Kontakt til kundesupport
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_da" title="Genbrug og bortskaffelse">
     Genbrug og bortskaffelse
    </a>
   </p>
   <div id="divd0e37808">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_da" title="Genbrug af Lexmark-produkter">
      Genbrug af Lexmark-produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_da" title="Genanvendelse af Lexmark-emballage">
      Genanvendelse af Lexmark-emballage
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_da" title="Beskeder">
     Beskeder
    </a>
   </p>
   <div id="divd0e37844">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37847" title="Produktinformation">
      Produktinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37864" title="Udgavemeddelelse">
      Udgavemeddelelse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_da" title="Varem&aelig;rker">
      Varem&aelig;rker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_da" title="Licensmeddelelser">
      Licensmeddelelser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_da" title="St&oslash;jemissionsniveauer">
      St&oslash;jemissionsniveauer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_da" title="Direktiv om affald af elektrisk og elektronisk udstyr (WEEE)">
      Direktiv om affald af elektrisk og elektronisk udstyr (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37967" title="Genopladeligt litium-ion-batteri">
      Genopladeligt litium-ion-batteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_da" title="Regulering (EU) 2023/1542">
      Regulering (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38005" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_da" title="Bortskaffelse af produktet">
      Bortskaffelse af produktet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_da" title="Returnering af Lexmark-tonerpatroner til genbrug eller genvinding">
      Returnering af Lexmark-tonerpatroner til genbrug eller genvinding
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_da" title="Meddelelse om statisk f&oslash;lsomhed">
      Meddelelse om statisk f&oslash;lsomhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_da" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_da" title="Temperaturoplysninger">
      Temperaturoplysninger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_da" title="Lasererkl&aelig;ring">
      Lasererkl&aelig;ring
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_da" title="Str&oslash;mforbrug">
      Str&oslash;mforbrug
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38266" title="Lovgivningsm&aelig;ssige oplysninger for tr&aring;dl&oslash;se produkter">
      Lovgivningsm&aelig;ssige oplysninger for tr&aring;dl&oslash;se produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_da" title="Meddelelse om modulkomponent">
      Meddelelse om modulkomponent
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_da" title="Uds&aelig;ttelse for radiofrekvens">
      Uds&aelig;ttelse for radiofrekvens
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38291" title="Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver">
      Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_da" title="Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver">
      Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_da" title="Bekendtg&oslash;relse om radiointerferens">
      Bekendtg&oslash;relse om radiointerferens
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue